import * as React from 'react'
import { faClose, FaIcon } from '@/lib/fa'

import useGroupService from '../../services/GroupService'
import { toast } from '@/lib/toasts/api'
import EditGroupDetailsModal from './EditGroupDetailsModal'
import ModalLayout from '../shared/ModalLayout'
import AddGroupsForm from '@/modules/drivers/forms/groups/AddGroupsForm'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddGroupModal = ({
  close,
  companyId,
  refreshGroups,
  openGroupMembers = false,
  isEdit = false,
}) => {
  const { t } = useLocalize()
  const { addGroup, getGroups } = useGroupService()

  const [newGroupName, setNewGroupName] = React.useState('')
  const [isAddGroupModelOpen, setIsAddGroupModelOpen] = React.useState(false)
  const [addedGroup, setAddedGroup] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const addDriverGroup = async () => {
    setLoading(true)
    try {
      if (isEdit) {
        await addGroup({ companyId: companyId, name: newGroupName })
      } else {
        await addGroup({ companyId: companyId, name: newGroupName })
      }
      toast.success({
        text: t('driverModule.group-added'),
      })
      if (openGroupMembers) {
        await getGroups({ companyId: companyId }).then((groups) => {
          setAddedGroup(groups.find((g) => g.name === newGroupName))
          setIsAddGroupModelOpen(true)
        })
      }
    } catch (err) {
      toast.error({
        text: t('driverModule.group-add-failed'),
      })
    } finally {
      setLoading(false)
      refreshGroups()
    }
  }

  return (
    <ModalLayout>
      <div className="tw-flex tw-max-h-[500px] tw-w-full tw-max-w-[480px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
          <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
            {isEdit ? t('driverModule.edit-group') : t('driverModule.add-new-group')}
          </p>
          <FaIcon
            icon={faClose}
            className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <AddGroupsForm
          setNewGroupName={setNewGroupName}
          newGroupName={newGroupName}
        />
        <div className="tw-flex tw-items-center tw-justify-end tw-border-t tw-border-base-300 tw-px-4">
          <div className="tw-my-4 tw-flex tw-items-center tw-gap-3">
            <button
              disabled={loading}
              type="button"
              onClick={() => addDriverGroup()}
              className={`$tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
            >
              {isEdit ? t('common.confirm') : t('driverModule.add-group')}
            </button>
          </div>
        </div>
      </div>
      {isAddGroupModelOpen && newGroupName && (
        <EditGroupDetailsModal
          companyId={companyId}
          group={addedGroup}
          close={() => close()}
        />
      )}
    </ModalLayout>
  )
}
export default AddGroupModal
